import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=6791f175&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=js"
export * from "./SettingsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791f175",
  null
  
)

export default component.exports